import type { FC, SyntheticEvent } from 'react';

import { ClickableDiv } from '@wwe-portal/ui/components/button';
import { cn } from '@wwe-portal/ui/lib/lib';

import { DynamicCountdown } from './shop-stepup-banner';

export interface StoreRevampBannerProps {
  endDate: string;
  banner: string;
  description?: string;
  onClick?: (e: SyntheticEvent) => void;
  onBannerClickMore?: (e: SyntheticEvent) => void;
}

export type StoreRevampBannerComponent =
  React.Component<StoreRevampBannerProps>;

export const StoreRevampBanner: FC<StoreRevampBannerProps> = ({
  endDate,
  banner,
  description,
  onClick,
  onBannerClickMore,
}) => {
  return (
    <ClickableDiv
      aria-hidden="true"
      className="rainbow animate-rotate-360 text-2xs absolute inset-0 cursor-pointer overflow-hidden rounded-md font-bold"
      onClick={onClick}
    >
      <div className="absolute inset-0">
        <div className="relative aspect-[384/174] w-full bg-[#1F233F]">
          <div className="absolute inset-0">
            <img
              alt="banner"
              className="h-full w-full object-cover"
              src={banner}
            />
          </div>
        </div>
      </div>
      <div className="absolute inset-x-0 bottom-0 h-[calc(18100%/379)] bg-[linear-gradient(180deg,rgba(31,35,63,0)_-0.47%,#1F233F_44.16%)]" />
      <div className="absolute bottom-0 left-0 right-0 flex h-[calc(5400%/180)] items-center justify-center">
        <span
          className={cn(
            'max-h-full max-w-[calc(26000%/379)] text-center uppercase text-white'
          )}
        >
          {description}
        </span>
      </div>
      <div className="absolute bottom-[calc(10200%/378)] flex h-[calc(2200%/180)] w-full items-center justify-center text-white">
        <DynamicCountdown
          className="aspect-[118/22] w-[calc(25000%/829)] uppercase"
          endDate={endDate}
        />
        <ClickableDiv
          className="bg-blue700 h-4 w-[70px] rounded-sm text-center"
          onClick={(e) => {
            e.stopPropagation();
            onBannerClickMore?.(e);
          }}
        >
          <span className="justify-center text-center text-[8px] font-semibold">
            MORE INFO
          </span>
        </ClickableDiv>
      </div>
    </ClickableDiv>
  );
};
